__turbopack_context__.v({
  "soldLabel": "styles-module__gNN0oW__soldLabel",
  "soldLabelLegacyButton": "styles-module__gNN0oW__soldLabelLegacyButton",
  "soldLabelThrift": "styles-module__gNN0oW__soldLabelThrift",
});
